export default function Badge({ children, color = "gray", dot = false, sm = false, className = "" }) {
  const cls = { green: "badge-success", red: "badge-danger", amber: "badge-warning", blue: "badge-primary", gray: "badge-gray", purple: "badge-purple", cyan: "badge-cyan", orange: "badge-orange" };
  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-full w-fit ${sm ? "px-1.5 py-px text-sm" : "px-2.5 py-0.5 text-xs"} ${cls[color] || cls.gray} ${className}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${color === "green" ? "bg-emerald-500" : color === "red" ? "bg-red-500" : color === "amber" ? "bg-amber-500" : "bg-blue-500"}`} />}
      {children}
    </span>
  );
}
